export const LOCAL_STORAGE_FLAGS = {
    experimentBeforeYouBegin: 'experiment-before-you-begin',
    experimentRecallEmail: 'experiment-recall-email',
    analysisStartedPopup: 'analysis-started-popup'
} as const;

/**
 * Reads boolean flag from localStorage, if local storage cannot be accessed, returns defaultValue (set to false, meaning pop up will show)
 */
export const getBooleanLocalStorageFlag = (key: string, defaultValue = false) => {
    try {
        return localStorage.getItem(key) === 'true';
    } catch {
        return defaultValue;
    }
};

/**
 * Stores a boolean flag in localStorage
 */
export const setBooleanLocalStorageFlag = (key: string, value: boolean) => {
    try {
        localStorage.setItem(key, value ? 'true' : 'false');
    } catch {
        // if storage is unavailable, skip
    }
};
